import { Question } from '@jupiterone/jupiter-types/question';
import { INSIGHTS_BASE_URL } from 'jupiter-web-insights/src/constants';
import useBoards from 'jupiter-web-insights/src/hooks/useBoards';
import { BoardType, InsightsBoard } from 'jupiter-web-insights/src/types';
import base64EncodeUnicode from '@jupiterone/jupiter-web-toolkit/src/util/base64EncodeUnicode';
import {
  useMockHook,
  mockFunction,
} from '@jupiterone/jupiter-web-toolkit/src/util/useMockHook';
import { useABAC } from '@jupiterone/jupiter-web-toolkit/src/api/fetch/useABAC';

interface AddToInsightsMenuProps {
  questionId?: Question['id'];
  query?: string;
  onClose?: VoidFunction;
}

const useAddToInsightsMenuLogic = ({
  questionId,
  query,
  onClose,
}: AddToInsightsMenuProps) => {
  const { teamBoards, userBoards } = useBoards();
  const { enforce } = useABAC();

  const handleAddToInsights = (
    boardType: BoardType,
    boardId?: InsightsBoard['id']
  ) => () => {
    const url = `${window.location.origin}${INSIGHTS_BASE_URL}/${boardType}${
      boardId ? `/${boardId}` : ''
    }?${questionId ? `questionId=${questionId}` : ''}${
      query ? `query=${base64EncodeUnicode(query)}` : ''
    }`;
    window.open(url, '_blank');
    onClose?.();
  };
  return {
    teamBoards,
    userBoards,
    isAdminInsight: enforce(['adminInsights']),
    handleAddToInsights,
  };
};

export type HookResolve = ReturnType<typeof useAddToInsightsMenuLogic>;

export const MOCK_ADD_TO_INSIGHTS_MENU_PROPS: HookResolve = {
  teamBoards: [],
  userBoards: [],
  isAdminInsight: false,
  handleAddToInsights: mockFunction,
};

export default useMockHook(
  useAddToInsightsMenuLogic,
  MOCK_ADD_TO_INSIGHTS_MENU_PROPS
);
